import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { UntilDestroy } from '@shared';

@UntilDestroy()
@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShellComponent implements OnInit {
  constructor(private breakpoint: BreakpointObserver) {}

  ngOnInit() {
    console.log('ShellComponent ngOnInit');
  }
}
